{
	"clickEditFiles": "Click Edit files in the alert above",
	"needsPermission": "{{productName}} needs this permission so you can process thousands of large raw files right inside your browser window."
}
